import axiosInstance from './axiosInstance';

const addPrivateCategory = async ({ token, title, description, subcategoryTitle, subcategoryDescription }) => {
  try {
    const response = await axiosInstance.post(
      '/privatecategories/add',
      { title, description, subcategoryTitle, subcategoryDescription },
      {
        headers: {
          Authorization: token,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error('Error posting data: ' + error.message);
  }
};

export { addPrivateCategory };
